import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrands } from "src/redux/actions/brand.action";
import { getDepts } from "src/redux/actions/department.action";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import SearchIcon from "@material-ui/icons/Search";
import { getYearList } from "src/redux/actions/purchaseRequest.action";
import { Alert, AlertTitle } from "@material-ui/lab";
import { hasRole } from "src/utils/Auth";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    lineHeight: "5ch",
    alignContent: "center",
    minWidth: "20ch",
  },
}));

export default function BudgetCodeSearchFormComponent({ onSubmit, roles }) {
  const classes = useStyles();

  const {
    result: { companyid, countryid },
  } = useSelector((state) => state.loginReducer);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  useEffect(() => {
    return () => {};
  }, []);

  const renderRoles = () => {
    if (!roles) {
      return <MenuItem>Loading...</MenuItem>;
    }

    if (hasRole(authorizePR.data, ["admin"])) {
      return _.filter(roles, function (o) {
        return o.NAME !== "super-admin";
      }).map((item) => (
        <MenuItem key={item.ID} value={item.ID}>
          {item.NAME}
        </MenuItem>
      ));
    } else {
      return roles.map((item) => (
        <MenuItem key={item.ID} value={item.ID}>
          {item.NAME}
        </MenuItem>
      ));
    }
  };

  return (
    <div className={classes.modal}>
      <Formik
        initialValues={{
          ROLE: "",
        }}
        validate={(values) => {
          const errors = {};

          if (!values.ROLE) {
            errors.ROLE = "The role must not be blank.";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          // search
          onSubmit(values);
          setSubmitting(false);
        }}
        render={({
          submitForm,
          resetForm,
          isSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <>
            <Grid container spacing={1}>
              <Grid item md={6} xs={12}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.ROLE && touched.ROLE && errors.ROLE)}
                >
                  <InputLabel id="select-year-label">
                    Please Select Role
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="ROLE"
                    label="Role"
                    labelId="select-role-label"
                    size="small"
                    error={Boolean(errors.ROLE && touched.ROLE && errors.ROLE)}
                    onChange={() => {}}
                    displayEmpty
                  >
                    {renderRoles()}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box display="flex">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={submitForm}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    Update Role By Selection
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={(e) => {
                      e.preventDefault();
                      resetForm({});
                    }}
                    disabled={isSubmitting}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      />
    </div>
  );
}
